import { Injectable, Type } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { ReplicaLookupService } from "../../impl/ReplicaLookupService";

import { IAutoCompleteLabelValuePromiseLookupService } from "../IAutoCompleteLabelValuePromiseLookupService";

import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { ClientAccountVisibilityType } from "../../../model/privatization/clientAccountVisibility/ClientAccountVisibilityType";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { AutoCompleteLabelValue } from "../../../model/core/AutoCompleteLabelValue";

export abstract class AutoCompleteLabelValueReplicaLookupService<
    K,
    V extends CubiqTS.ConcreteEncodable,
  >
  extends ReplicaLookupService<K, V>
  implements IAutoCompleteLabelValuePromiseLookupService
{
  constructor(
    protected factory: ClientMessageBrokerFactory,
    protected lookupType: Type<CubiqTS.ConcreteEncodable>,
    protected serviceChannel: string,
    protected modelUpdateEventType: Type<CubiqTS.ConcreteEncodable> = CubiqTS.ModelUpdateImpl,
    protected autoSubscribeUpdates: boolean = true,
    protected baseLookupService: BaseLookupService<K, V> = null,
  ) {
    super(
      factory,
      lookupType,
      serviceChannel,
      modelUpdateEventType,
      autoSubscribeUpdates,
      baseLookupService,
    );
  }

  getLabelValueById(opts?: {
    prefix?: String;
    skip?: number;
    limit?: number;
  }): Promise<AutoCompleteLabelValue[]> {
    let request = new UiArguments("getLabelValueById");
    request.args = opts ? [new FnArg(opts, PRIMITIVE)] : [];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getLabelValueByName(opts?: {
    prefix?: String;
    skip?: number;
    limit?: number;
  }): Promise<AutoCompleteLabelValue[]> {
    let request = new UiArguments("getLabelValueByName");
    request.args = opts ? [new FnArg(opts, PRIMITIVE)] : [];
    return this.broker.runOnService(request, PRIMITIVE);
  }
}
